import withQueryStringProps from './withQueryStringProps';
export default withQueryStringProps;



// WEBPACK FOOTER //
// ./src/components/withQueryStringProps/index.js